// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompareItemNav_trigger__EP6\\+q {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-color);
  cursor: pointer;
}
.CompareItemNav_trigger__EP6\\+q.CompareItemNav_white-theme__YvlcG {
  color: white;
}

.CompareItemNav_badge__6Y-VO {
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: var(--accent-color);
  color: var(--text-0, #fff);
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.CompareItemNav_drawer__9fvtr {
  width: 349px;
  height: 100vh;
  overflow-y: auto;
  background: var(--background-color-1);
}
.CompareItemNav_drawer__header__dKL89 {
  display: flex;
  height: var(--navbar-height);
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid var(--light-grey);
  background: var(--background-color-2);
  color: var(--accent-color);
}
.CompareItemNav_drawer__header--title__H9qIq {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}
.CompareItemNav_drawer__actions__4mPgG {
  padding: 16px;
  border-bottom: 1px solid var(--light-grey);
}
.CompareItemNav_drawer__benchmark-link__uyQ2V {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: var(--accent-color);
  text-decoration: none;
}
.CompareItemNav_drawer__benchmark-link__uyQ2V:hover {
  text-decoration: underline;
}
.CompareItemNav_drawer__content__kS3ba {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.CompareItemNav_drawer__section__Ufuhq {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.CompareItemNav_drawer__section-title__xKXGE {
  font-size: 14px;
  font-weight: 600;
  color: var(--grey-text);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.CompareItemNav_drawer__row__4fp-M {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: var(--background-color-2);
  border: 1px solid var(--light-grey);
}
.CompareItemNav_drawer__row-label__6qfBA {
  flex: 1 1;
  min-width: 0;
  font-size: 15px;
  color: var(--text-1, #333);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.CompareItemNav_drawer__empty__6Q7Fm {
  padding: 24px 16px;
  text-align: center;
  color: var(--grey-text);
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Navbar/Components/CompareItemNav/CompareItemNav.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,qCAAA;AAAF;AAEE;EACE,aAAA;EACA,4BAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,0CAAA;EACA,qCAAA;EACA,0BAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAAN;AAIE;EACE,aAAA;EACA,0CAAA;AAFJ;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;AAHJ;AAKI;EACE,0BAAA;AAHN;AAOE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AALJ;AAQE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mCAAA;AARJ;AAWE;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATJ;AAYE;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAVJ","sourcesContent":[".trigger {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-color);\n  cursor: pointer;\n\n  &.white-theme {\n    color: white;\n  }\n}\n\n.badge {\n  position: absolute;\n  top: -6px;\n  right: -8px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  border-radius: 9px;\n  background: var(--accent-color);\n  color: var(--text-0, #fff);\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n}\n\n.drawer {\n  width: 349px;\n  height: 100vh;\n  overflow-y: auto;\n  background: var(--background-color-1);\n\n  &__header {\n    display: flex;\n    height: var(--navbar-height);\n    padding: 0 16px;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n    border-bottom: 1px solid var(--light-grey);\n    background: var(--background-color-2);\n    color: var(--accent-color);\n\n    &--title {\n      font-size: 20px;\n      font-weight: 700;\n      margin: 0;\n    }\n  }\n\n  &__actions {\n    padding: 16px;\n    border-bottom: 1px solid var(--light-grey);\n  }\n\n  &__benchmark-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 600;\n    color: var(--accent-color);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  &__content {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__section-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--grey-text);\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  &__row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: var(--background-color-2);\n    border: 1px solid var(--light-grey);\n  }\n\n  &__row-label {\n    flex: 1;\n    min-width: 0;\n    font-size: 15px;\n    color: var(--text-1, #333);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__empty {\n    padding: 24px 16px;\n    text-align: center;\n    color: var(--grey-text);\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `CompareItemNav_trigger__EP6+q`,
	"white-theme": `CompareItemNav_white-theme__YvlcG`,
	"badge": `CompareItemNav_badge__6Y-VO`,
	"drawer": `CompareItemNav_drawer__9fvtr`,
	"drawer__header": `CompareItemNav_drawer__header__dKL89`,
	"drawer__header--title": `CompareItemNav_drawer__header--title__H9qIq`,
	"drawer__actions": `CompareItemNav_drawer__actions__4mPgG`,
	"drawer__benchmark-link": `CompareItemNav_drawer__benchmark-link__uyQ2V`,
	"drawer__content": `CompareItemNav_drawer__content__kS3ba`,
	"drawer__section": `CompareItemNav_drawer__section__Ufuhq`,
	"drawer__section-title": `CompareItemNav_drawer__section-title__xKXGE`,
	"drawer__row": `CompareItemNav_drawer__row__4fp-M`,
	"drawer__row-label": `CompareItemNav_drawer__row-label__6qfBA`,
	"drawer__empty": `CompareItemNav_drawer__empty__6Q7Fm`
};
export default ___CSS_LOADER_EXPORT___;
